import { ReviewImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/reviewImpression.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const getBazaarvoiceImpression = (
    data: TypedAnalyticsEvent<ReviewImpressionTrackingInfo>
) => {
    const eventData = data.payload.eventData;

    const impressionData: BV.ImpressionData = {
        bvProduct: "RatingsAndReviews",
        contentId: eventData.contentId,
        productId: eventData.productId,
        brand: eventData.brand,
        categoryId: eventData.categoryId,
        contentType: "review"
    };

    return impressionData;
};
